export enum ParentalRelationship {
  FATHER = 'Father',
  MOTHER = 'Mother',
  Guradian = 'Guardian',
}
